/** Shared storage key names for the cache/version-management system. */
export const APP_VERSION_STORAGE_KEYS = {
  buildVersion: 'app_build_version',
  buildTime: 'app_build_time',
  reloadGuard: 'app_reload_guard'
};

/**
 * Shape of `assets/version.json`, generated at build time by
 * `scripts/generate-version.js`. Represents the build that is actually
 * deployed/bundled in the currently served web assets.
 */
export interface LocalBuildVersionInfo {
  buildVersion: string;
  buildTime: string;
}

/**
 * Shape of the optional remote version-policy endpoint. Configured via
 * `environment.remoteVersionConfigUrl`. Lets a backend force clients on an
 * old/broken build to update without shipping a new native binary.
 */
export interface RemoteVersionConfig {
  latestVersion: string;
  minimumVersion: string;
  forceUpdate: boolean;
}

/** Persisted guard used to detect and stop reload loops within a session. */
export interface ReloadGuardState {
  version: string;
  attempts: number;
}
